import React from "react";
import MDTypography from "materialDashboard/components/MDTypography";
import Stack from "@mui/material/Stack";
import {Icon} from "@mui/material";


const UnauthorizedRole = () => {

    return <Stack alignItems="center" justifyContent="center" height="60vh">
        <Icon sx={{fontSize: "56px!important"}}>lock</Icon>
        <MDTypography variant="h1" color="text" fontWeight="medium" textAlign="center">
            Access Denied
        </MDTypography>
        <MDTypography textAlign="center">
            You do not have permission to access this page.
        </MDTypography>
    </Stack>
}

export default UnauthorizedRole